/**
 * FaqJsonLd — emits FAQPage JSON-LD schema for homepage or any page with Q&A.
 *
 * Unlocks FAQ rich-snippet eligibility in Google SERPs (the expandable
 * Q&A dropdowns that take up double-height real estate). Google strongly
 * rewards real, specific homeowner questions — avoid generic marketing fluff.
 *
 * Usage:
 *   <FaqJsonLd items={[
 *     { q: 'What is a Growing Degree Day?', a: 'A GDD is…' },
 *   ]} />
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const FaqJsonLd = ({ items }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default FaqJsonLd;
